import {make_createActionType} from '../helpers'
const createActionType = make_createActionType('DB_APP')

export const NEW_USER_MSG = createActionType('NEW_USER_MSG')
export const NEW_USER_QUICK_REPLY = createActionType('NEW_USER_QUICK_REPLY')
export const DROPDOWN_ITEM_CLICK = createActionType('DROPDOWN_ITEM_CLICK')
export const FETCH_BOT_RESPONSE_SUCCESS = createActionType('FETCH_BOT_RESPONSE_SUCCESS')
export const BOT_INITIALIZED = createActionType('BOT_INITIALIZED')
export const START_CONVERSATION = createActionType('START_CONVERSATION')
export const CLOSE_CONVERSATION = createActionType('CLOSE_CONVERSATION')
export const MENU_ITEM_CLICK = createActionType('MENU_ITEM_CLICK')
export const LOAD_HISTORY = createActionType('LOAD_HISTORY')
export const START_POLLING = createActionType('START_POLLING')
export const STOP_POLLING = createActionType('STOP_POLLING')




// WEBPACK FOOTER //
// ./src/App/constants.js